import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonUtil, MessageService } from '@serengeti/serengeti-common';

@Pipe({
  name: 'userProfileImage'
})
export class UserProfileImagePipe implements PipeTransform {

  endPoint: string;
  
  defaultImageSrc = '/assets/images/user/user.png' as any;
  
  constructor(private messageService: MessageService) {
    this.endPoint = CommonUtil.buildEndPoint(environment.serviceUserEndPoint, 'user');
  }

  transform(value: any, id?: any): any {
		this.messageService.file(CommonUtil.buildEndPoint(this.endPoint, '/' + value + '/avatar/'), 
    null, 'image/png', 'blob').subscribe((image: any) => {
          const element = document.getElementById(id) as any;
          if (image.size !== 0) {
            const reader = new FileReader();
      
            reader.onload = () => {
              if (element) {
                element.src = reader.result;
              }
            };
            reader.onerror = () => {
              if (element) {
                element.src = this.defaultImageSrc;
              }
            };
            reader.readAsDataURL(image);
          } else {
            element.src = this.defaultImageSrc;
          }
      });
  }

}
